import React from 'react';

interface Props {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
  ariaLabel: string;
  iconColor?: string;
  iconBg?: string;
}

export const ActionPill: React.FC<Props> = ({
  icon,
  label,
  onClick,
  ariaLabel,
  iconColor,
  iconBg,
}) => (
  <button
    type="button"
    aria-label={ariaLabel}
    onClick={onClick}
    style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 6,
      background: 'var(--bl-surface)',
      border: '1px solid var(--bl-divider)',
      borderRadius: 14,
      minHeight: 64,
      padding: '10px 8px',
      cursor: 'pointer',
      fontFamily: 'inherit',
      WebkitTapHighlightColor: 'transparent',
    }}
  >
    <div
      style={{
        width: 36,
        height: 36,
        borderRadius: 10,
        flexShrink: 0,
        background: iconBg ?? 'var(--bl-surface)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 16,
        color: iconColor ?? 'var(--bl-primary)',
      }}
    >
      {icon}
    </div>
    <span
      style={{
        fontSize: 12,
        fontWeight: 600,
        color: 'var(--bl-text)',
        textAlign: 'center',
        lineHeight: 1.2,
      }}
    >
      {label}
    </span>
  </button>
);
